export const fetchFeaturedNews = async (news = "", limit = null) => {
    const API_URL = process.env.REACT_APP_BKND_URL;
    const res = await fetch(`${API_URL}/get-blogs.php?type=${news}${limit !== null ? `&limit=${limit}` : ''}`);
    return await res.json();
};
